import React, { useEffect, useState, useRef } from "react";
import { MessageCirclePlus, Pause, Play } from "lucide-react";
import useLocalization from "../../../../hooks/useLocalization";
import { useAppContext } from "../../../../context/AppContext";
import { useDispatch } from "react-redux";
import {
    clearInputValue,
    setInputDisabled,
    setIsNewChatClicked,
    setMicButtonDisabled,
    setSendButtonDisabled,
} from "../../../../store/features/ui/uiSlice";
import {
    deleteDataForTextLockFlow,
    deleteDataForVoiceLockFlow,
    setIsHideUserInputFields,
    setIsSuggestedQuestionsVisible,
    setSelectedChatId,
    setSelectedSocketLanguageData,
} from "../../../../store/features/message/textContentSlice";

function GrivanceNotRelatedToCpgram({ isNotRelatedToGrievance, message }) {
    const [timer, setTimer] = useState(59);
    const [isPaused, setIsPaused] = useState(false);
    const timerRef = useRef(null);

    const { t } = useLocalization();
    const { sharedApiService, setIsNewChat,setSelectedLanguageData } = useAppContext();
    const dispatch = useDispatch();

    const handleNewChat = () => {
        setSelectedLanguageData({ code: "en", label: "English" });
        dispatch(setSelectedChatId(null));
        setIsNewChat(true);
        sharedApiService.cancelAllRequests();
        dispatch(clearInputValue());
        dispatch(setSelectedSocketLanguageData(null));
        dispatch(deleteDataForVoiceLockFlow());
        dispatch(deleteDataForTextLockFlow());
        dispatch(setIsHideUserInputFields(false));
        dispatch(setIsSuggestedQuestionsVisible(true));
        dispatch(setInputDisabled(false));
        dispatch(setSendButtonDisabled(false));
        dispatch(setMicButtonDisabled(false));
        dispatch(setIsNewChatClicked(true));
    };


    useEffect(() => {
        if (!isNotRelatedToGrievance || isPaused) return;

        timerRef.current = setInterval(() => {
            setTimer((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timerRef.current);
    }, [isNotRelatedToGrievance, isPaused]);

    // ✅ NEW EFFECT — safely triggers new chat
    useEffect(() => {
        if (timer <= 0 && isNotRelatedToGrievance) {
            handleNewChat();
        }
    }, [timer, isNotRelatedToGrievance]);


    const togglePause = () => setIsPaused(!isPaused);

    if (!isNotRelatedToGrievance) return null;

    return (
        <div className="w-full mt-4 animate-fadeIn">
            <div
                className="
                    p-6 rounded-3xl border border-blue-100
                    bg-gradient-to-br from-blue-50 to-blue-100/50
                    shadow-sm hover:shadow-md
                    backdrop-blur-xl
                    transition-all duration-300
                "
            >
                {/* Message */}
                <p className="text-blue-800 text-[15px] leading-relaxed">
                    {message}
                </p>

                {/* Timer Row */}
                <div className="mt-4 flex items-center gap-3">
                    <span className="text-sm text-blue-700">
                        {t("newChat")}
                    </span>

                    {/* Timer Pill */}
                    <span
                        className="
                            px-3 py-1 rounded-full bg-blue-600 text-white 
                            text-sm font-semibold shadow-sm
                        "
                    >
                        {timer}s
                    </span>

                    {/* Play / Pause */}
                    <button
                        onClick={togglePause}
                        className="
                            p-1.5 rounded-full bg-blue-200 
                            text-blue-700 hover:bg-blue-300
                            shadow transition-all active:scale-95
                        "
                    >
                        {isPaused ? <Play size={16} /> : <Pause size={16} />}
                    </button>
                </div>

                {/* New Chat Button */}
                <button
                    onClick={handleNewChat}
                    className="
                        mt-5 w-full flex items-center justify-center gap-2
                        bg-blue-600 hover:bg-blue-700
                        text-white font-semibold py-3 
                        rounded-2xl shadow-md hover:shadow-lg 
                        transition-all active:scale-95
                    "
                >
                    <MessageCirclePlus size={20} />
                    {t("newChat")}
                </button>
            </div>
        </div>
    );
}

export default GrivanceNotRelatedToCpgram;
